import { useState } from "react";

/**
 * Inline "why?" prompt — a text field with confirm/cancel. Used when an
 * action should leave a note behind (e.g. dropping a planned purchase).
 */
export default function ReasonPrompt({ placeholder = "Reason…", confirmLabel = "Confirm", onConfirm, onCancel }) {
  const [reason, setReason] = useState("");
  const submit = () => onConfirm(reason.trim());
  return (
    <div className="flex items-center gap-1.5 w-full">
      <input
        autoFocus
        type="text"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") submit();
          if (e.key === "Escape") onCancel();
        }}
        placeholder={placeholder}
        className="flex-1 min-w-0 text-[11px] text-gray-200 rounded px-2 py-1 outline-none focus:ring-1 focus:ring-indigo-500 placeholder-gray-500"
        style={{ background: "var(--bg-input)", border: "1px solid var(--border-input)" }}
      />
      <button
        onClick={submit}
        className="px-2 py-1 text-[10px] font-medium rounded bg-red-600 hover:bg-red-500 text-white whitespace-nowrap"
      >
        {confirmLabel}
      </button>
      <button onClick={onCancel} className="px-2 py-1 text-[10px] text-gray-400 hover:text-gray-200">
        Cancel
      </button>
    </div>
  );
}
